module.exports = __webpack_public_path__ + "static/media/20ECE28.83882d6f.jpg";